import { useEffect, useState } from 'react';
import { berlinIsoDate } from './berlinCalendar';

const CHECK_INTERVAL_MS = 60_000;

/** Keeps the previous instant while Berlin is still on the same calendar day. */
export const advanceToday = (previous: Date, now: Date) =>
  berlinIsoDate(previous.toISOString()) === berlinIsoDate(now.toISOString()) ? previous : now;

/**
 * The current instant, replaced only when the Berlin day changes: a tab left open
 * overnight moves on to the new month and escalation countdown.
 */
export const useToday = () => {
  const [today, setToday] = useState(() => new Date());

  useEffect(() => {
    const refresh = () => setToday((previous) => advanceToday(previous, new Date()));
    const interval = window.setInterval(refresh, CHECK_INTERVAL_MS);

    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);

    return () => {
      window.clearInterval(interval);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);

  return today;
};
